class LPAccordion extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    this.questionEl = this.querySelector(".lp_accordion-item-question");
    this.answerEl = this.querySelector(".lp_accordion-item-answer");

    // Prepare answer panel for animation
    this.answerEl.style.overflow = "hidden";
    this.answerEl.style.height = "0px";
    this.answerEl.style.transition = "height 0.3s ease";

    // Click to toggle
    this.questionEl.addEventListener("click", () => this.toggle());
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();

      // OPTIONAL: close siblings
      const siblings = [...this.parentElement.querySelectorAll("lp-accordion")];
      siblings.forEach((acc) => {
        if (acc !== this) acc.close();
      });
    }
  }

  open() {
    this.isOpen = true;
    this.classList.add("open");

    const fullHeight = this.answerEl.scrollHeight;
    this.answerEl.style.height = fullHeight + "px";
  }

  close() {
    this.isOpen = false;
    this.classList.remove("open");

    this.answerEl.style.height = "0px";
  }
}

customElements.define("accordion-item", LPAccordion);
